import { useMutation, useQueryClient } from '@tanstack/react-query';

import { StartNewsProfileResponse } from '../api';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const useStartNewsProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      clientAxios.post<ApiResponse<StartNewsProfileResponse>>(
        '/startNewsProfileApi/'
      ),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['getProfileIdApi'],
      });
    },
  });
};

export default useStartNewsProfile;
